// github.com/vercel/next.js/issues/5354#issuecomment-520305040
const isServer = (): boolean => typeof window === 'undefined'

export default isServer
